<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <div class="text-center">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" @click="overlay = false"></v-progress-circular>
          </v-overlay>
        </div>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size:30px; color:white;" class="mb-0">Usuarios</p>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="d-flex justify-end">
        <v-btn-toggle class="mb-0 pb-0" center>
          <v-btn @click="registro=true">Registro</v-btn>
          <v-btn @click="registro=false">Listado</v-btn>
        </v-btn-toggle>
      </v-col>
      <!-- Datos empleado -->
      <v-col cols="12" md="12" sm="12" xs="12" lg="7" xl="7" v-if="registro">
        <v-card mx-auto outlined>
          <v-row dense class="ma-3">
            <v-col cols="12" md="12" sm="12" xs="12" lg="8" xl="8">
              <v-autocomplete
                v-model="usuario"
                :items="empleadosselect"
                :search-input.sync="searchempleado"
                flat
                hide-no-data
                hide-details
                label="Buscar colaborador..."
                solo-inverted
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="4" xl="4" class="d-flex justify-end">
              <v-btn-toggle>
                <v-btn @click="editItem">Consultar</v-btn>
                <v-btn @click="limpiar">Nuevo</v-btn>
              </v-btn-toggle>
            </v-col>
            <!-- Informacion empleado -->
            <v-col cols="12" md="12" sm="12" xs="12" class="pt-5" dense>
              <span class="font-weight-bold primary--text">Datos personales</span>
              <v-row dense>
                <v-col cols="12" md="6" sm="12" xs="12">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="dni"
                        label="DNI"
                        dense
                        :rules="[() => !!dni || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="dni"
                        v-mask="'########'"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="nombres"
                        label="Nombres"
                        dense
                        class="pt-0"
                        :rules="[() => !!nombres || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="nombres"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="apellidos"
                        label="Apellidos"
                        dense
                        class="pt-0"
                        :rules="[() => !!apellidos || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="apellidos"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-divider class="mx-4" vertical></v-divider>
                <v-col cols="12" md="12" sm="12" xs="12" lg="5" xl="5">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-autocomplete
                        v-model="empresaid"
                        :items="empresas"
                        label="Empresa"
                        class="pt-0"
                        ref="empresaid"
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-autocomplete
                        v-model="idcontratistas"
                        :items="contratistas"
                        label="Empresas Constratistas"
                        class="pt-0"
                        ref="idcontratistas"
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-select
                        :items="roles"
                        v-model="rol"
                        label="Rol"
                        dense
                        class="pt-0"
                        :rules="[() => !!rol || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="rol"
                        required
                      ></v-select>
                    </v-col>
                    <!--<v-col cols="12" md="6" sm="12" xs="12" dense class="pt-5">
                      <v-select
                        :items="estadoscivil"
                        v-model="estado_civil"
                        label="Estado civil"
                        dense
                        class="pt-0"
                      ></v-select>
                    </v-col>
                    <v-col cols="6" md="6" sm="6" xs="12" dense class="pt-5">
                      <v-text-field v-model="telefono" label="Telefono" dense class="pt-0"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" dense class="pt-0">
                      <v-text-field v-model="email" label="Email" dense class="pt-0"></v-text-field>
                    </v-col>-->
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn color="primary" class="mb-5" @click="save" :disabled="overlay2">Guardar</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="5" xl="5" dense v-if="registro">
        <v-card class="mx-auto" outlined>
          <v-row dense class="pa-3">
            <!-- Usuario-->
            <v-col cols="12" md="12" sm="12" xs="12" dense>
              <v-row class="px-5">
                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense>
                  <span class="font-weight-bold primary--text">Acceso a EmpleoMatch</span>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                  <v-text-field
                    v-model="usuario2"
                    label="Usuario"
                    class="pt-0"
                    dense
                    :rules="[() => !!usuario2 || 'Campo requerido']"
                    :error-messages="errorMessages"
                    ref="usuario2"
                    :disabled="!nuevo"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                  <v-text-field
                    class="pt-0"
                    dense
                    v-model="contraseña"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[() => !!contraseña || 'Campo requerido']"
                    :type="show1 ? 'text' : 'password'"
                    label="Contraseña"
                    @click:append="show1 = !show1"
                    :error-messages="errorMessages"
                    ref="contraseña"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense v-else>
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="empleado_headers"
                :items="empleados"
                :search="searchempleados"
                sort-by="empresa"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2">Usuarios</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-dialog v-model="adModal" max-width="290px">
                      <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">
                          <span class=".font-weight-thin">¿Activar item?</span>
                        </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">
                          <span class=".font-weight-thin">¿Desactivar item?</span>
                        </v-card-title>
                        <v-card-text>
                          Estas a punto de
                          <span v-if="adAccion==1">activar</span>
                          <span v-if="adAccion==2">desactivar</span>
                          el item asoaciado a
                          <strong>{{adNombre}}</strong>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            outlined
                            @click="ActivarDesactivarCerrar()"
                          >Cancelar</v-btn>
                          <v-btn
                            v-if="adAccion==1"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Activar()"
                          >Activar</v-btn>
                          <v-btn
                            v-if="adAccion==2"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Desactivar()"
                          >Desactivar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchempleados"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <!-- Template para condicion -->
                <template v-slot:item.condicion="{ item }">
                  <v-switch v-model="item.condicion" inset @change="ActivarDesactivar(item)"></v-switch>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemEmpleado(item)"
                  >mdi-square-edit-outline</v-icon>
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{icon}}</v-icon>
        {{error}}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
export default {
  data() {
    return {
      //Ayuda
      show1: false,
      registro: true,
      nuevo: true,
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      overlay: false,
      overlay2: false,
      snackbar: false,
      error: null,
      errorMessages: "",
      form1HasErrors: false,
      color: "#2A3B4D",
      icon: "mdi-thumb-up",

      //Tablas
      empleado_headers: [
        { text: "Empresa", value: "empresa_mostrar" },
        { text: "Nombres", value: "nombres" },
        { text: "Apellidos", value: "apellidos" },
        { text: "DNI", value: "dni" },
        { text: "Usuario", value: "usuario" },
        { text: "Rol", value: "rol" },
        { text: "Estado", value: "condicion", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      empleados: [],
      empresas: [],
      contratistas: [],
      empresaid: null,
      idcontratistas: null,
      empleadosselect: [],
      searchempleado: "",
      searchempleados: "",
      /*Datos personales */
      sexos: [
        { text: "Varon", value: "MA" },
        { text: "Mujer", value: "FE" },
      ],
      estadoscivil: [
        { text: "Soltero(a)", value: "SOLTERO(A)" },
        { text: "Comprometido(a)", value: "COMPROMETIDO(A)" },
        { text: "Conviviente", value: "CONVIVIENTE" },
        { text: "Casado(a)", value: "CASADO(A)" },
        { text: "Separado(a)", value: "SEPARADO(A)" },
        { text: "Divorciado(a)", value: "DIVORCIADO(A)" },
        { text: "Viudo(a)", value: "VIUDO(A)" },
      ],
      roles: [
        { text: "Administrador", value: "ADMINISTRADOR" },
        { text: "Proveedor Local", value: "PROVEEDOR" },
        { text: "Contratista", value: "CONTRATISTA" },
      ],
      idempleado: "",
      dni: "",
      nombres: "",
      apellidos: "",
      fecha_nacimiento: new Date().toISOString().substr(0, 10),
      sexo: "",
      telefono: "",
      email: "",
      estado_civil: "",
      usuario: "",
      usuario2: "",
      contraseña: "",
      rol: "",

      /*Soporte*/
      valida: 0,
      validamensaje: [],
    };
  },
  created() {
    let me = this;
    me.listar();
    me.selectEmpleado();
    me.selectEmpresa();
    me.selectEmpresasContratistas();
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        //me.overlay=false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },

  computed: {
    form1() {
      return {
        dni: this.dni,
        nombres: this.nombres,
        apellidos: this.apellidos,
        rol: this.rol,
        usuario2: this.usuario2,
        contraseña: this.contraseña,
      };
    },
  },
  methods: {
    remove(item) {
      const index = this.clasificacion_locacion.indexOf(item);
      if (index >= 0) this.clasificacion_locacion.splice(index, 1);
    },
    /*Empresa*/
    selectEmpresa() {
      let me = this;
      me.empresas = [];
      let Array = [];
      axios
        .get("api/Empresas/Listar")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.empresas.push({ text: x.razonsocial, value: x.idempresa });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    selectEmpresasContratistas() {
      let me = this;
      var Array = [];
      me.contratistas = [];
      axios
        .get("api/Contratistas/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.contratistas.push({ text: x.empresa_contratista, value: x.id_empresa_contratista });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        });
    },
    /*Empleado*/
    ActivarDesactivar(item) {
      //La adAccion 1 = Activar y 2 = Desactivar
      this.adModal = 1;
      this.adNombre = item.nombres;
      this.adId = item.usuario;
      if (item.condicion) {
        this.adAccion = 1;
      } else {
        this.adAccion = 2;
      }
    },
    ActivarDesactivarCerrar() {
      this.adModal = 0;
      this.listar();
      this.selectEmpleado();
    },
    Activar() {
      let me = this;
      axios
        .put("/api/Usuarios/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
          me.selectEmpleado();
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    Desactivar() {
      let me = this;
      axios
        .put("/api/Usuarios/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
          me.selectEmpleado();
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.form1HasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) this.form1HasErrors = true;
        this.$refs[f].validate(true);
      });
    },
    editItemEmpleado(item) {
      this.overlay = true;
      this.idempleado = item.idempleado;
      this.registro = true;
      this.editItem();
      this.overlay = false;
    },
    /* Tabla */
    listar() {
      let me = this;
      me.empleados = [];

      axios
        .get("api/Usuarios/Listar")
        .then(function (response) {

          me.empleados = response.data.map(e => ({
            ...e,
            empresa_mostrar: e.nombre_empresa || e.nombre_empresa_contratista
          }));

        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    selectEmpleado() {
      let me = this;
      var Array = [];
      me.empleadosselect = [];
      axios
        .get("api/Usuarios/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.empleadosselect.push({ text: x.usuariofinal, value: x.usuario });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        });
    },
    editItem() {
      this.overlay = true;
      let me = this;
      var Array = [];
      me.selectEmpresa();
      axios
        .get("api/Usuarios/Mostrar/" + me.usuario)
        .then(function (response) {
          me.usuario2 = response.data.usuario;
          me.dni = response.data.dni;
          me.nombres = response.data.nombres;
          me.apellidos = response.data.apellidos;
          me.contraseña = response.data.contraseña;
          me.rol = response.data.rol;
          me.condicion = response.data.condicion;
          me.empresaid = response.data.idempresa;
          me.editedIndex = 1;
          me.nuevo = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      this.overlay = false;
    },
    editItemEmpleado(item) {
      let me = this;
      me.registro = true;
      me.usuario2 = item.usuario;
      me.usuario = item.usuario;
      me.dni = item.dni;
      me.nombres = item.nombres;
      me.apellidos = item.apellidos;
      me.contraseña = item.contraseña;
      me.rol = item.rol;
      me.condicion = item.condicion;
      me.empresaid = item.idempresa;
      me.editedIndex = 1;
      me.nuevo = false;
    },
    limpiar() {
      let me = this;
      me.dni = "";
      me.nombres = "";
      me.apellidos = "";
      me.usuario = "";
      me.usuario2 = "";
      me.contraseña = "";
      me.rol = "";
      me.condicion = "";
      me.empresaid = null;
      me.idcontratistas = null;
      me.editedIndex = -1;
      me.nuevo = true;
      me.selectEmpresa();
      me.selectEmpresasContratistas();
    },
    save() {
      this.validar1();
      if (this.form1HasErrors == false) {
        if (this.editedIndex > -1) {
          let me = this;
          axios
            .put("/api/Usuarios/Actualizar", {
              usuario: me.usuario,
              contraseña: me.contraseña,
              dni: me.dni,
              nombres: me.nombres.toUpperCase(),
              apellidos: me.apellidos.toUpperCase(),
              rol: me.rol,
              idempresa: me.empresaid,
              id_empresa_contratista: me.idcontratistas,
            })
            .then(function (response) {
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.editedIndex = 1;
              me.selectEmpleado();
              me.listar();
              me.nuevo = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        } else {
          let me = this;
          axios
            .post("/api/Usuarios/Crear", {
              usuario: me.usuario2,
              contraseña: me.contraseña,
              dni: me.dni,
              nombres: me.nombres.toUpperCase(),
              apellidos: me.apellidos.toUpperCase(),
              rol: me.rol,
              idempresa: me.empresaid,
              id_empresa_contratista: me.idcontratistas,
              condicion: true,
            })
            .then(function (response) {
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.editedIndex = 1;
              me.selectEmpleado();
              me.listar();
              me.nuevo = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        }
      }
    },
    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
  },
};
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
.my-input {
  text-transform: uppercase;
}
</style>